import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_app/admin/automations/$organizationId/$automationId',
)({
    component: () => <Outlet />,
});
